import * as Vue from "vue";
import * as VueRouter from "vue-router";
import * as Vuex from "vuex";
import Axios from "axios";
import "lightgallery.js";

(<any>window).Vue = Vue;
(<any>window).Vuex = Vuex;
(<any>window).VueRouter = VueRouter;
(<any>window).Axios = Axios;